import { StaticPageModule } from './app.module';

import { bootstrapAppModule } from 'Angular/utils/app-bootstrapping';

bootstrapAppModule(StaticPageModule);
